import { memo } from 'react';

import { RadioButton } from '@gem/ui-kit';

import styles from './FormRadioButton.styles.m.css';
import { IFormRadioButtonProps } from './FormRadioButton.types';

export const FormRadioButton = memo<IFormRadioButtonProps>((props) => {
  const {
    input: { name, checked, onChange, value },
    label,
  } = props;

  return (
    <RadioButton
      theme={checked ? 'primary' : 'secondary'}
      className={styles.button}
      label={label}
      name={name}
      value={value}
      checked={!!checked}
      onChange={onChange}
    />
  );
});
